import styled from 'styled-components';

export const CardRowTextContainer = styled.div<{ justifyContent: string; noPadding: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.justifyContent};
  &:not(:last-of-type) {
    padding-bottom: ${props => (props.noPadding ? 0 : props.theme.space.s3)};
  }
  width: 100%;
`;
